import { createLucideIcon } from "lucide-react";

export const PdfFile = createLucideIcon(
    "PdfFile",
    [
        [
            "path",
            {
                d: "M11.332 12.6667H12.9987",
                key: "1eygdn",
            },
        ],
        [
            "path",
            {
                d: "M11.332 14.6667V12.6667",
                key: "uzj7x7",
            },
        ],
        [
            "path",
            {
                d: "M13.6654 10.6667H12.6654C12.0368 10.6667 11.7226 10.6667 11.5273 10.862C11.332 11.0573 11.332 11.3715 11.332 12.0001V12.6667",
                key: "341rka",
            },
        ],
        [
            "path",
            {
                d: "M2.332 12.6667V11.4667C2.332 11.0896 2.332 10.9011 2.4492 10.7839C2.5664 10.6667 2.7549 10.6667 3.132 10.6667H3.6654C4.2177 10.6667 4.6654 11.1145 4.6654 11.6667C4.6654 12.219 4.2177 12.6667 3.6654 12.6667H2.332Z",
                key: "1thvbf",
            },
        ],
        [
            "path",
            {
                d: "M2.332 14.6667V12.6667",
                key: "ew6uax",
            },
        ],
        [
            "path",
            {
                d: "M2.33333 8C2.33333 6.7727 3.32826 5.77778 4.55556 5.77778C4.99941 5.77778 5.52269 5.85555 5.95424 5.73992C6.33768 5.63718 6.63718 5.33768 6.73992 4.95424C6.85555 4.52269 6.77778 3.99941 6.77778 3.55556C6.77778 2.32826 7.7727 1.33333 9 1.33333",
                key: "14l6s4",
            },
        ],
        [
            "path",
            {
                d: "M2.33464 8.66675V8.13094C2.33464 6.15269 2.33464 5.16357 2.64726 4.37358C3.14985 3.10356 4.21273 2.10178 5.56021 1.62809C6.39839 1.33344 7.44784 1.33344 9.54676 1.33344C10.7461 1.33344 11.3458 1.33344 11.8248 1.50181C12.5948 1.77249 13.2021 2.34493 13.4893 3.07066C13.668 3.52208 13.668 4.0873 13.668 5.21772V8.00956V8.66675",
                key: "1ea71o",
            },
        ],
        [
            "path",
            {
                d: "M9.332 12.6667C9.332 13.7713 8.4366 14.6667 7.332 14.6667C7.0828 14.6667 6.9582 14.6667 6.8654 14.6132C6.6431 14.4849 6.6654 14.2251 6.6654 14.0001V11.3334C6.6654 11.1084 6.6431 10.8486 6.8654 10.7203C6.9582 10.6667 7.0828 10.6667 7.332 10.6667C8.4366 10.6667 9.332 11.5622 9.332 12.6667Z",
                key: "1ojl8i",
            },
        ],
    ],
);
